import { useState } from 'react'
import BlurHashImage from '@components/BlurHashImage'
import { imageLoadCache } from '@utils/image-load-cache'

/**
 * BlurImage
 * Shows a BlurHash canvas placeholder until the image loads.
 * Cache-aware: blur only appears on the FIRST load per session.
 * Subsequent remounts (e.g. navigation back) skip the placeholder.
 *
 * @param {string}  hash               - BlurHash string
 * @param {string}  src                - Image src
 * @param {string}  alt                - Image alt text
 * @param {string}  [className]        - Class applied to <img>
 * @param {string}  [wrapperClassName] - Class applied to the wrapper div
 * @param {object}  [wrapperStyle]     - Extra inline styles for the wrapper div
 */
function BlurImage({ hash, src, alt, className, wrapperClassName, wrapperStyle, ...imgProps }) {
  // Start as "loaded" if already seen this session → canvas renders invisible immediately
  const [loaded, setLoaded] = useState(() => imageLoadCache.has(src))

  return (
    <div
      className={wrapperClassName}
      style={{ position: 'relative', overflow: 'hidden', ...wrapperStyle }}
    >
      <BlurHashImage hash={hash} fadeOut={loaded} />
      <img
        src={src}
        alt={alt}
        className={className}
        onLoad={() => {
          imageLoadCache.add(src)
          setLoaded(true)
        }}
        {...imgProps}
      />
    </div>
  )
}

export default BlurImage
